// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {setArrayKey} from "../../utils/misc";


class RoomCreateModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            button: {
                icon: this.props.icon ? this.props.icon : AddCircleIcon,
                label: this.props.label ? this.props.label : 'Добавить',
                color: this.props.color ? this.props.color : 'primary',
            },
            modalLabel: 'Добавить чат',
            modalIcon: AssignmentIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            flat: true,
            ready: true,
        })
    }

    async retrieveFields() {
        const url = `room/create_form/`;
        const api = new BaseApi();
        let fields = ['title',]
        if (this.props.xtype === 'BOT'){
            fields.push('bot')
        }
        const params = {
            fields: JSON.stringify(fields)
        }
        let response = await api.get(
            url,
            params
        );
        let formFields = response.data
        if (this.props.pushFirstMessage){
            formFields = [
                {
                    name: 'push_first_message',
                    label: 'Отправить как сообщение',
                    xs: 12,
                    sm: null,
                    lg: null,
                    xl: null,
                    required: false,
                    default: false,
                    type: 'checkbox',
                },
                ...formFields,
            ]
        }
        if (this.props.xtype === 'BOT') {
            formFields = setArrayKey(
                formFields,
                'name',
                'bot',
                'required',
                true
            );
        }

        return (formFields)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        formDataObj.xtype = this.props.xtype
        const url = `room/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (this.props.callBack) {
                await this.props.callBack(response.data?.id)
            }
            this.setModalOpenFalse();
        }
        return response
    }
}

export default RoomCreateModal